import { useCanUserDoOnProject } from "../../../canUserDo";

export function useUserCanRead(projectId: string) {
  return useCanUserDoOnProject("DASHBOARD_READ", projectId);
}
